import { PartnerConfigContext } from '@percent/product-nomination-form/context/partnerConfig/PartnerConfigContext/PartnerConfigContext'
import { useContext } from 'react'

export const usePartnerConfig = () => {
  const context = useContext(PartnerConfigContext)

  if (context === undefined) {
    throw new Error(
      'usePartnerConfig must be used within a NominationFormContextController'
    )
  }

  return context
}
